module.exports = __webpack_public_path__ + "img/reading.c71a2d6.svg";